import { ProductCard } from './ProductCard'
import type { ShopProductDocument } from '../types'

interface ProductGridProps {
  products: ShopProductDocument[]
}

export function ProductGrid({ products }: ProductGridProps) {
  if (products.length === 0) {
    return (
      <div className="py-20 text-center text-muted-foreground">
        No products available right now. Check back soon.
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  )
}
